import { render } from "./FeatureFlags.vue?vue&type=template&id=67086876"
import script from "./FeatureFlags.vue?vue&type=script&lang=js"
export * from "./FeatureFlags.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Admin/FeatureFlags/FeatureFlags.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67086876"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67086876', __exports__)) {
    api.reload('67086876', __exports__)
  }
  
  module.hot.accept("./FeatureFlags.vue?vue&type=template&id=67086876", () => {
    api.rerender('67086876', render)
  })

}


export default __exports__